// extracted by mini-css-extract-plugin
export default {"button":"sb-button_button__CP6fK","yearBelow":"sb-button_yearBelow__sUXV0","year":"sb-button_year__ED4-V","image":"sb-button_image__Ci+xS"};